export enum EJoinSource {
  SCAN_AND_PAY = 'qr-scan-pay',
  ORDER_AND_PAY = 'qr-order-pay',
  OLO_WEB = 'olo-web',
}
